import React from 'react';

export default class TripleStateCheckbox extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            checked: this.props.checked
        };

        this.element = null;
    }

    componentDidMount() {
        this.syncCheckboxProperties();
    }

    componentWillReceiveProps(newProps) {
        this.setState(
            {
                checked: newProps.checked
            },
            () => {
                this.syncCheckboxProperties();
            }
        );
    }

    syncCheckboxProperties() {
        this.element.indeterminate = this.state.checked === null;
    }

    handleValueChange(newChecked) {
        if (this.state.checked === null) {
            newChecked = false;
        }
        if (this.props.onChange) {
            this.props.onChange(newChecked);
        }
    }

    render() {
        let isChecked = this.state.checked === true;
        return (
            <input type="checkbox"
                ref={e => this.element = e}
				className={this.props.className}
                checked={isChecked}
                onChange={e => this.handleValueChange(e.target.checked)}
                disabled={this.props.disabled} />
        );
    }
}


// WEBPACK FOOTER //
// ./App/controls/tripleStateCheckbox.jsx